/**
 * Plan 12, Task 6.3 — Scene fog.
 *
 * Attaches exponential fog to the scene with a warm sunset-tinted color.
 * FogExp2 affects all MeshStandardMaterial objects automatically.
 * ShaderMaterials (sky, clouds, bridges) are NOT affected by scene.fog.
 */

import * as THREE from 'three';

export interface FogConfig {
  readonly color?: THREE.ColorRepresentation;
  readonly density?: number;
}

export interface FogResult {
  /** The fog instance attached to the scene. */
  readonly fog: THREE.FogExp2;
  /** Dispose (removes fog from scene). */
  dispose(scene: THREE.Scene): void;
}

/**
 * Attach exponential fog to the scene.
 * FogExp2 with a warm sunset-tinted color (#C4A882) and density 0.012.
 * Applied to scene.fog — affects all MeshStandardMaterial objects automatically.
 * ShaderMaterials (sky, clouds, bridges) are NOT affected by scene.fog.
 */
export function attachFog(scene: THREE.Scene, config?: FogConfig): FogResult {
  const fog = new THREE.FogExp2(config?.color ?? 0xc4a882, config?.density ?? 0.012);
  scene.fog = fog;

  return {
    fog,
    dispose(s: THREE.Scene): void {
      s.fog = null;
    },
  };
}
